export interface IGetMedicationDetailsEndpointResponse {
  content: string;
  id: string;
  title: string;
}

export const getMedicationDetailsEndpoint = (id: string) =>
  `/medications/${id}`;
